var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasToShowOnboarding ? _c('div', {
    ref: "onboardingPanel",
    staticClass: "onboarding-panel onboarding-panel-size border-radius-small d-flex",
    class: {
      'panel-size-increased-on-specialties': _vm.hasToShowSpecialtyStep,
      'no-top-left': _vm.hasToShowKeywordsPanel && _vm.$vuetify.breakpoint.xsOnly,
      'panel-size-increased-on-keywords': _vm.hasToShowKeywordsPanel,
      'panel-size-increased-on-ethics': _vm.hasToShowEthicsPanel
    }
  }, [_vm.hasToShowWelcomeSteps ? _c('v-row', {
    staticClass: "justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0",
    class: {
      'align-content-start': _vm.$vuetify.breakpoint.xsOnly
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "col-sm-4 col-lg-auto text-center",
    class: [{
      'adjust-images-for-tablet-and-up': _vm.$vuetify.breakpoint.smAndUp
    }, _vm.hasToAdjustImagesHeadingForSEPhones ? 'mb-4 mt-2' : 'col-12']
  }, [_c('OnboardingImagesHandlerComponent', {
    attrs: {
      "current-step-index": _vm.currentStepIndex,
      "enum-steps": _vm.enumOnboarding
    }
  })], 1), _vm.hasToAdjustImagesHeadingForSEPhones ? _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex > _vm.enumOnboarding.INTRO && _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT,
      expression: "currentStepIndex > enumOnboarding.INTRO && currentStepIndex < enumOnboarding.POST_CHECKOUT"
    }],
    staticClass: "heading number-step-box mr-2 primary--text",
    class: _vm.calculateClassForNumber
  }, [_c('span', [_vm._v(_vm._s(_vm.currentStepIndex))])]), _c('h3', {
    staticClass: "heading primary--text",
    class: _vm.titleClassName
  }, [_vm._v(" " + _vm._s(_vm.titleForSteps) + " ")])])], 1) : _vm._e(), _c('v-col', {
    staticClass: "content-onboarding col-12 col-sm-8 col-lg pl-sm-3 py-0"
  }, [!_vm.hasToAdjustImagesHeadingForSEPhones ? _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex > _vm.enumOnboarding.INTRO && _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT,
      expression: "currentStepIndex > enumOnboarding.INTRO && currentStepIndex < enumOnboarding.POST_CHECKOUT"
    }],
    staticClass: "heading number-step-box mr-2 primary--text",
    class: _vm.calculateClassForNumber
  }, [_c('span', [_vm._v(_vm._s(_vm.currentStepIndex))])]), _c('h3', {
    staticClass: "heading primary--text mt-1 mt-sm-0",
    class: _vm.titleClassName
  }, [_vm._v(" " + _vm._s(_vm.titleForSteps) + " ")])]) : _vm._e(), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('p', {
    ref: "descriptions",
    staticClass: "descriptions mt-2 mb-4 text text-l-large-regular word-wrap-all",
    class: {
      'pl-sm-15 pl-lg-8': !_vm.$vuetify.breakpoint.xsOnly && _vm.currentStepIndex === _vm.enumOnboarding.POST_CHECKOUT
    },
    domProps: {
      "innerHTML": _vm._s(_vm.items[_vm.currentStepIndex].desc)
    }
  })]), _c('v-row', {
    staticClass: "mt-sm-0 pl-sm-3",
    class: [_vm.currentStepIndex === _vm.enumOnboarding.POST_CHECKOUT ? 'mt-0' : '', {
      'fixed-bottom-mobile': _vm.$vuetify.breakpoint.xsOnly,
      'fixed-actions-nonmobile': !_vm.$vuetify.breakpoint.xsOnly
    }],
    attrs: {
      "no-gutters": "",
      "justify-sm": "space-between"
    }
  }, [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT && !_vm.$vuetify.breakpoint.xsOnly,
      expression: "currentStepIndex < enumOnboarding.POST_CHECKOUT && !$vuetify.breakpoint.xsOnly"
    }],
    attrs: {
      "cols": "12",
      "sm": "auto",
      "align-self": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, _vm._l(4, function (index) {
    return _c('DotComponent', {
      key: index,
      staticClass: "clickable",
      attrs: {
        "index": index - 1,
        "current-step-index": _vm.currentStepIndex
      },
      on: {
        "clicked": function ($event) {
          return _vm.goToStep(index - 1);
        }
      }
    });
  }), 1)]), _c('v-col', {
    staticClass: "col-12 text-right align-self-center",
    class: {
      'col-sm-12 mb-sm-1': _vm.currentStepIndex >= _vm.enumOnboarding.POST_CHECKOUT,
      'col-sm-auto': _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT,
      'buttons-disposition-mobile': _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasToShowBackButton,
      expression: "hasToShowBackButton"
    }],
    staticClass: "primary--text heading heading-s-small align-self-center unaltered-text-cap letter-spacing-normal shadow-light-button px-4 mr-sm-4 mt-4 mt-sm-0",
    attrs: {
      "ripple": "",
      "depressed": "",
      "block": _vm.$vuetify.breakpoint.xsOnly,
      "height": _vm.$vuetify.breakpoint.xsOnly ? '44px' : '36px',
      "color": "grey lighten-5"
    },
    on: {
      "click": _vm.goStepBack
    }
  }, [_vm._v(" Back ")]), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex === _vm.enumOnboarding.INTRO,
      expression: "currentStepIndex === enumOnboarding.INTRO"
    }],
    staticClass: "primary--text heading heading-s-small align-self-center unaltered-text-cap mt-4 mt-sm-0 mr-sm-4",
    class: {
      'shadow-light-button': _vm.$vuetify.breakpoint.xsOnly
    },
    attrs: {
      "ripple": "",
      "text": !_vm.$vuetify.breakpoint.xsOnly,
      "depressed": "",
      "block": _vm.$vuetify.breakpoint.xsOnly,
      "height": _vm.$vuetify.breakpoint.xsOnly ? '44px' : '36px',
      "color": _vm.$vuetify.breakpoint.xsOnly ? 'grey lighten-5' : ''
    },
    on: {
      "click": _vm.skipOnboarding
    }
  }, [_vm._v(" Skip ")]), _c('v-btn', {
    staticClass: "heading heading-s-small align-self-center unaltered-text-cap shadow-light-button px-6",
    attrs: {
      "ripple": "",
      "depressed": "",
      "block": _vm.$vuetify.breakpoint.xsOnly,
      "height": _vm.$vuetify.breakpoint.xsOnly ? '44px' : '36px',
      "color": "primary white--text"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(" " + _vm._s(_vm.items[_vm.currentStepIndex].useBtnPrimaryAlternative ? _vm.items[_vm.currentStepIndex].btnPrimaryAlternative : _vm.items[_vm.currentStepIndex].btnPrimary) + " ")])], 1), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT && _vm.$vuetify.breakpoint.xsOnly,
      expression: "currentStepIndex < enumOnboarding.POST_CHECKOUT && $vuetify.breakpoint.xsOnly"
    }],
    staticClass: "justify-center",
    class: [{
      'd-flex': _vm.currentStepIndex < _vm.enumOnboarding.POST_CHECKOUT && _vm.$vuetify.breakpoint.xsOnly
    }, _vm.$vuetify.breakpoint.width > _vm.PHONE_WIDTH ? 'mt-8' : 'mt-6'],
    attrs: {
      "cols": "12",
      "sm": "4",
      "align-self": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, _vm._l(4, function (index) {
    return _c('DotComponent', {
      key: index,
      staticClass: "clickable",
      attrs: {
        "index": index - 1,
        "current-step-index": _vm.currentStepIndex
      },
      on: {
        "clicked": function ($event) {
          return _vm.goToStep(index - 1);
        }
      }
    });
  }), 1)])], 1)], 1)], 1) : _vm._e(), _vm.hasToShowNavbar ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.$vuetify.breakpoint.xsOnly && (_vm.currentStepIndex === _vm.enumOnboarding.SPECIALTY_STEP || _vm.currentStepIndex === _vm.enumOnboarding.KEYWORDS_STEP) ? _c('v-app-bar', {
    staticClass: "app-bar",
    attrs: {
      "app": "",
      "color": "var(--v-background-base)",
      "flat": ""
    }
  }, [_c('ph-caret-left', {
    staticClass: "clickable",
    attrs: {
      "weight": "thin",
      "size": "24",
      "color": "var(--v-grey-darken4)"
    },
    on: {
      "click": function ($event) {
        return _vm.goToStep(_vm.currentStepIndex - 1);
      }
    }
  }), _c('h6', {
    staticClass: "text text-l-large-regular grey--text text--darken-3 ml-2",
    on: {
      "click": function ($event) {
        return _vm.goToStep(_vm.currentStepIndex - 1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.backNavbarButtonTextToShow) + " ")])], 1) : _vm._e()], 1) : _vm._e(), _vm.hasToShowSpecialtyStep ? _c('v-row', {
    staticClass: "justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('SpecialtyListComponent', {
    attrs: {
      "check-for-guest-specialties": true
    },
    on: {
      "show-again-welcome-steps": _vm.goStepBack,
      "finish-specialties-selection": _vm.nextStep
    }
  })], 1) : _vm._e(), _vm.hasToShowKeywordsPanel ? _c('v-row', {
    staticClass: "justify-space-around fix-last-step-overflow pa-6 pa-sm-10 mb-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('KeywordListComponent', {
    attrs: {
      "has-to-show-toast": true,
      "has-to-use-inner-scroll": true
    },
    on: {
      "show-again-welcome-steps": _vm.goStepBack,
      "skip-keywords-selection": _vm.handleSkipKeywordsSelection,
      "finish-keywords-selection": _vm.handleFinishKeywordsSelection
    }
  })], 1) : _vm._e(), _vm.hasToShowEthicsPanel ? _c('v-row', {
    staticClass: "justify-space-around fix-last-step-overflow no-overflow-y pa-6 pa-sm-10 mb-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('EthicsComponent', {
    on: {
      "next-step": _vm.nextStep
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }